import React from "react";
import { theme, Tooltip, Modal, Select, Button } from 'antd';
import {
  PlusCircleFilled,
  ClearOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  CloseCircleFilled,
  CheckCircleFilled,
  DeleteOutlined,
  PlusCircleOutlined,
  FilePdfOutlined
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_CHEMICAL } from "../../constants/urls";
import { currencyFormat, toHumanDate } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import { DELETE, POST } from "../../frameworks/HttpClient";
import AddStockQualityChemicalModal from "./AddStockQualityChemicalModal";
import { useNavigate } from "react-router-dom";
import { PATH } from "../../routes/CustomRoutes";
import _ from "lodash";
import QualityChemicalWeightPopover from "./QualityChemicalWeightPopover";
import QualityChemicalChangeTankPopover from "./QualityChemicalChangeTankPopover";

export default function QualityChemicalStockList(props) {
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ stockTarget, setStockTarget] = React.useState(null);
  const [ filterClose, setFilterClose] = React.useState(false);
  const [ tableKey, setTableKey] = React.useState(0);
  const navigate = useNavigate();
  const tableRef = React.useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken();

  const { token : { colorError, colorPrimary, colorWarning }} = theme.useToken();

  const onChangeFilter = (value) => {
    setFilterClose(value)
  };

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 200,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.is_closed && <Tooltip triger='hover' title="ล้างสต๊อก">
              <ColorButton 
                type='primary'
                override={colorPrimary}
                icon={<ClearOutlined />}
                style={{ margin : 5}}
                onClick={()=> confirm(original.lot_no, original.id)} 
              />
            </Tooltip>}
            {!original.is_closed && <Tooltip triger='hover' title="ลบสต๊อก">
              <ColorButton
                type='primary'
                override={colorError}
                icon={<DeleteOutlined />}
                style={{ margin : 5}}
                onClick={()=> confirmDelete(original.lot_no, original.id)} 
              />
            </Tooltip>}
            <Tooltip triger='hover' title="เพิ่มสารตั้งต้น">
              <ColorButton 
                type='primary'
                override={colorSuccess}
                icon={<PlusCircleOutlined />}
                style={{ margin : 5}}
                onClick={()=> navigate(`${PATH.PRECURSOR_CHEMICAL}/${original.id}`)} 
              />
            </Tooltip>
            {!original.is_closed && <Tooltip triger='hover' title="แก้ไข">
              <ColorButton 
                type='primary'
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={()=> setStockTarget(original)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'เริ่มวันที่',
      dataIndex: 'created',
      key: 'created',
      render: (value) => toHumanDate(value)
    },
    {
      title: 'วันที่แก้ไขลาสุด',
      dataIndex: 'updated',
      key: 'updated',
      render: (value) => toHumanDate(value)
    },
    {
      title: 'ชื่อสารเคมี',
      dataIndex: 'chemical_name',
      key: 'chemical_name',
      searcher: true,
    },
    {
      title: 'Lot No.',
      dataIndex: 'lot_no',
      key: 'lot_no',
      searcher: true,
      render : (value, original) => value ? 
      <>
        {value}
        <Tooltip title={"รายละเอียดสต๊อกสารเคมีคุณภาพ"}>
          <Button
            color='primary' 
            variant='link'
            icon={<FilePdfOutlined />}
            onClick={()=> window.open(`${window.origin}${PATH.QUALITY_CHEMICAL_SUMMARY}/${original.id}/`)}
          />
        </Tooltip>
      </> : '-'
    },
    {
      title: 'แทงก์',
      dataIndex: 'tank_name',
      key: 'tank_name',
      searcher: true,
      render: (value, original) => (
        <center>
          {value}
          { !original.is_closed && (
            <QualityChemicalChangeTankPopover target={original.id} onUpdate={() => refreshData()}/>
          )}
        </center>
      )
    },
    {
      title: 'ปริมาณนำเข้า',
      dataIndex: 'amount',
      key: 'amount',
      render: (value, original) => {
        return (
        <center>
          {currencyFormat(value)}
            {!original.is_closed && 
              <QualityChemicalWeightPopover
                title={"สต๊อกสารเคมี"}
                target={original}
                onUpdate={() => refreshData()}
              >
                <Tooltip triger='hover' title={"กรอกน้ำหนัก"}>
                  <EditOutlined
                    style={{ color: colorWarning, marginLeft: 5 }}
                  />
                </Tooltip>
              </QualityChemicalWeightPopover>}
        </center>
      )}
    },
    {
      title: 'จ่ายออก',
      dataIndex: 'used_amount',
      key: 'used_amount',
      render : (value) => <center>{currencyFormat(value)}</center>
    },
    {
      title: 'คงเหลือ',
      dataIndex: 'remain_amount',
      key: 'remain_amount',
      render : (value) => <center>{currencyFormat(value)}</center>
    },
    {
      title: 'สถานะ',
      dataIndex: 'is_closed',
      key: 'is_closed',
      render : (value) =>  <center>{value ? <CloseCircleFilled style={{ color : colorError}}/> : <CheckCircleFilled style={{ color : colorSuccess}}/>}</center>
    },
  ]

  const confirm = (title, value) => {
    Modal.confirm({
      title: `ล้างสต๊อกสารเคมี - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการล้างสต๊อกใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleClearStock(value)
        refreshData();
      },
    });
  };

  const confirmDelete = (title, value) => {
    Modal.confirm({
      title: `ลบสต๊อกสารเคมี - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการลบสต๊อกใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleDeleteStock(value)
        refreshData();
      },
    });
  };

  const handleClearStock = async(id) => {
    setErrorMessages(null)
    try {
      await POST(`${URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION}${id}/close/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const handleDeleteStock = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }


  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetch()
    )
  }

  const resetFilter = async() => {
    setTableKey(tableKey => tableKey + 1);
  }

  React.useEffect(() => {
    resetFilter();
  },[filterClose])

  return(
    <div>
      <ErrorMessages message={errorMessages}/>
        สถานะ : 
      <Select
        style={{width : 250, marginLeft : 10}}
        value={filterClose}
        placeholder="สถานะการใช้งาน"
        autoComplete="off"
        options={[
          {
            label : "ทั้งหมด",
            value : ''
          },
          {
            label : "ใช้งาน",
            value : false
          },
          {
            label : "ไม่ใช้งาน-หมด",
            value : true
          },
        ]}
        onChange={onChangeFilter}
      />
      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setStockTarget('add')}>
          {"เพิ่มสต๊อกสารเคมีคุณภาพ"}
      </ColorButton>

      <TSTable
        key={tableKey}
        ref={tableRef}
        columns={columns}
        size={'small'}
        pageSize={50}
        url={URL_CHEMICAL.QUALITY_CHEMICAL_TANK_TRANSACTION}
        params={{is_closed : filterClose, ordering : 'chemical_name'}}
      />

      <AddStockQualityChemicalModal
        open={stockTarget ? true : false}
        onClose={() => setStockTarget(null)}
        onUpdate={() => {
          setStockTarget(null)
          refreshData();
        }}
        target={stockTarget}
      />
    </div>
  )
}